/**
 * Time-of-day greeting for dashboard headers.
 * Morning before 12, Afternoon before 17, Evening afterward.
 */
import { formatDisplayName } from "./userDisplay"

export const getTimeOfDayGreeting = (date = new Date()) => {
  const hour = date.getHours()
  if (hour < 12) return "Good Morning"
  if (hour < 17) return "Good Afternoon"
  return "Good Evening"
}

export const formatDashboardGreeting = (firstName, date = new Date()) => {
  const greeting = getTimeOfDayGreeting(date)
  const name = formatDisplayName(firstName)
  return name ? `${greeting}, ${name}` : greeting
}
